<template>
  <v-dialog v-model="toggle" persistent width="500">
    <v-card outlined class="text-center r0">
      <!-- <div><v-icon>mdi-close</v-icon></div> -->
      <v-container>
        <template>
          <span class="mt-5"
            >{{ $t('Step') }} 2 :
            {{ $t('Choose options to upload image') }}</span
          >
          <div class="mt-10" style="text-align: -webkit-center">
            <v-btn
              style="display: grid; justify-content: left"
              height="46"
              width="92%"
              outlined
              class="btn-custom bg-two-tone btn-width-mobile"
              @click="goToCreateRichmenu('single')"
            >
              <v-img
                width="60"
                class="ml-3 mr-3"
                src="/img/LineRichmenu/icons/Rectangle.png"
              ></v-img>
              <span style="font-size: 20px">{{ $t('Upload an image') }}</span>
            </v-btn>
            <v-btn
              style="display: grid; justify-content: left"
              height="46"
              width="92%"
              outlined
              class="btn-custom bg-two-tone mt-5 btn-width-mobile"
              @click="goToCreateRichmenu('multi')"
            >
              <v-img
                width="60"
                src="/img/LineRichmenu/icons/6Rectangle.png"
                class="ml-3 mr-3"
              ></v-img>
              <span style="font-size: 20px">{{
                $t('Upload multiple images')
              }}</span>
            </v-btn>

            <v-btn
              width="344"
              height="46"
              outlined
              class="btn-back-richmenu mt-5 pa-5 btn-width-mobile"
              @click="close"
            >
              <span style="font-size: 20px">{{ $t('Cancel') }}</span>
            </v-btn>
          </div>
        </template>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['value'],
  data() {
    return {
      toggle: this.value
    }
  },
  computed: {
    ...mapGetters({
      templateSelect: 'lineRichmenuManager/getTemplateSelect'
    })
  },
  methods: {
    goToCreateRichmenu(type) {
      var prefix = window.location.hostname == 'app.zwiz.ai' ? 'z_' : ''
      if (type === 'single') {
        this.$gtag.event('event', {
          event_category: prefix + 'Step2 Create richmenu single image'
          // event_label: bot.pagename + utm,
        })
      } else {
        this.$gtag.event('event', {
          event_category: prefix + 'Create richmenu multiple image'
          // event_label: bot.pagename + utm,
        })
      }
      this.templateSelect.type = type
      this.$store.dispatch(
        'lineRichmenuManager/setTemplateSelect',
        this.templateSelect
      )
      this.$emit('goToPage3')
    },

    close() {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped></style>
